import {useRef, useEffect, useState} from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../global.state';
import firebase from "firebase/compat";
import {preparePrincipal} from "../models/Principal";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;


export function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export function usePrincipal<T>(ref: firebase.firestore.DocumentReference): [principal: T | undefined, isLoading: boolean] {
  const [principal, setPrincipal] = useState<T>();
  const [isLoading, setIsLoading] = useState(false);

  // obter dados derivados
  useEffect(() => {
    (async() => {
      setIsLoading(true);
      setPrincipal(undefined);
      const _principal = await ref.get();
      setPrincipal(preparePrincipal(_principal));
      setIsLoading(false);
    })();
  }, [ref]);

  return [principal, isLoading];
}